import Vue from 'vue'
import Vuex from 'vuex'
import appSetting from '../../public/appsettings.json'
import { Login } from '../components/CmpLogin/Store/StoreLogin'

// import createPersistedState from "vuex-persistedstate";

export const URL = appSetting.ApiUrl
export const List = {}
Vue.use(Vuex)
export const store = new Vuex.Store({
  // plugins: [
  //     createPersistedState({ storage: window.sessionStorage })
  // ],
  state: {
    Mojoodibaje: 0,
    ForceLoginpage: false,
    loadingRender: false,
    JalaliDate: '',
    loading: false,
    JalaliDateAndTime: '',
    JalaliDateAndTime: '',
    JalaliDateAndTime: '',
    JalaliDateAndTime: '',
    JalaliDateAndTime: '',
    VersionSoftware: '2.4.0330',
    DarkMode: true,
    ListUserGrpMenu: {},
    IsShowMenu: '',
    Theme: 'bg-BlueGreen',
    ThemeModal: 'bg-DefModal',
    SizeIcon: 25,
    Menu: {
      DefineShobe: 'تعریف سازمان',
      DefineInfoSystem: 'سیستم های اطلاعاتی',
      TarifSematha: 'تعریف سمت ها',
      TarifKarbaran: 'تعریف کاربران',
      UserLogInformation: 'اطلاعات فرم ها',
      ActiveItemRibbon: '',
      DefineDastresi: 'دسترسی به امکانات',
      TanzimatUser: 'تنظیمات کاربری',
      AnvaHesab: 'انواع حساب',
      Hoze: 'انواع حوزه',
      AnvaMoshtarian: 'انواع مشتریان',
      Jobs: 'شغلها',
      AzaInfo: 'ایجاد مشتری',
      Vorodi: 'جستجوی مشتریان',
      AzaPasAndJari: 'حساب های پس انداز و جاری مشتری',
    },

    ComponentInToModal: { Frm: '' },
    posts: null,
    Login: [],
    rows: [],
    columns: [],
    DataSanad: [],
    idForUpdate: null,
    renderComponent: true,
    renderComponentGrid: true,
    renderComponentTree: true,
    renderComponentFilterForm: false,
    renderComponentDlgCart: false,
    Pagnation: false,
    TreeItemSelected: null,
    renderComponentGridOneToMeny: true,
    PanelRout: [],
    FirstClickOnMenu: true,
    objectLogInformation: {
      UserId: 1,
      FkId: 293516,
      IsDelete: 0,
      ZamanLog: '',
      MasterLink: '',
      MasterTable: '',
      FormName: 'انواع حوزه',
      Shenase: null,
      UserNameFamily: 'راهبرسيستم',
      FormId: 'frmHoze',
      tblShobeId: 2,
      MacAddress: '',
      IpAddress: '',
      TblBnpCashLogRiz: [],
    },
    OldDataForLog: '',
    Information: null,
    DoreMaliData: [],
    SarfaslHayeMojaz: [],
    TanzimatPublic: [],
    b_SabtSandDaem: null,
    renderForm: true,
    renderComponentperferaj: true,
    NameSandogh: '',
    Netpa_Cart: [],
    FileBackupOnline: [],
  },
  getters: {},
  actions: {
    SetCoolGrid({ commit }, columns) {
      commit('UpdateColGrid', columns)
    },
  },
  mutations: {
    // removepanelitem: (i, state) => {
    //     console.log(state.PanelRout);
    //     console.log(i);
    //     // state.PanelRout.splice(index, 1);
    // },
    ReboonMiniSize: (state) => {
      if (state.IsShowMenu == '') {
        state.IsShowMenu = 'd-none'
        state.SizeIcon = 20
      } else {
        state.IsShowMenu = ''
        state.SizeIcon = 25
      }
    },
    ChangeTheme: (state) => {
      if (state.Theme == 'bg-BlueGreen') {
        state.Theme = 'bg-Custom'
      } else {
        state.Theme = 'bg-BlueGreen'
      }
    },
    OpenModal: () => {
      document.getElementById('#openModal').showModal()
    },

    UpdateColGrid(state, columns) {
      state.columns = columns
    },
  },
  modules: {
    login: Login,
  },
})
